import { Component, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
import { AsyncPipe, LowerCasePipe } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { Globals } from '@core/globals';
import { IconComponent } from '@atoms/icon/icon.component';
import { StickerComponent } from '@atoms/sticker/sticker.component';
import { CardComponent } from '@molecules/card/card.component';
import { CardBottomComponent } from '@molecules/card/card-bottom/card-bottom.component';
import { CardHeaderComponent } from '@molecules/card/card-header/card-header.component';
import { CardImportantComponent } from '@molecules/card/card-important/card-important.component';
import { CardListComponent } from '@molecules/card/card-list/card-list.component';
import { CardListItemComponent } from '@molecules/card/card-list-item/card-list-item.component';
import { CardMainComponent } from '@molecules/card/card-main/card-main.component';
import { CardPhotoComponent } from '@molecules/card/card-photo/card-photo.component';
import { CardPriceComponent } from '@molecules/card/card-price/card-price.component';
import { CardTitleComponent } from '@molecules/card/card-title/card-title.component';
import { CardTopComponent } from '@molecules/card/card-top/card-top.component';
import { FloatNumberPipe } from '@pipes/float-number.pipe';
import { MonthPipe } from '@pipes/month.pipe';
import { PricePipe } from '@pipes/price.pipe';
import { ThousandsPipe } from '@pipes/thousands.pipe';
import { ListItem } from '@models/list.model';

@Component({
  selector: 'app-car-card',
  imports: [
    AsyncPipe,
    TranslateModule,
    LowerCasePipe,
    IconComponent,
    StickerComponent,
    CardComponent,
    CardBottomComponent,
    CardHeaderComponent,
    CardImportantComponent,
    CardListComponent,
    CardListItemComponent,
    CardMainComponent,
    CardPhotoComponent,
    CardPriceComponent,
    CardTitleComponent,
    CardTopComponent,
    FloatNumberPipe,
    MonthPipe,
    PricePipe,
    ThousandsPipe,
  ],
  templateUrl: './car-card.component.html',
  styleUrls: ['./car-card.component.scss'],
})
export class CarCardComponent implements OnInit, OnChanges {
  public globals = inject(Globals);
  @Input() car?: ListItem;
  @Input() priority: boolean = false;
  @Input('is-reccommender') isRecommender: boolean = false;
  public photo?: string;

  updatePhoto(): void {
    if (!this.car) return;
    let photosArray: string[] | undefined = this.car.photos.default[0].url;
    if (!photosArray) return;
    this.photo = photosArray[0].replace(/\d+x\d+x\d+/, '556x410x100');
  }

  ngOnInit(): void {
    this.updatePhoto();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['car'] && changes['car'].currentValue !== changes['car'].previousValue) this.updatePhoto();
  }
}
